import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideEchartsCore } from 'ngx-echarts';

import {
  apiBaseInterceptor,
  authInterceptor,
  errorInterceptor,
  refreshInterceptor,
} from './core/http';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(
      // Order matters. Outgoing: top-down. Response/error: bottom-up.
      //   1. apiBase prepends the base URL → subsequent interceptors see absolute URLs
      //   2. auth attaches the Bearer token
      //   3. error handles 4xx (non-401), 5xx, network failures
      //   4. refresh (innermost) catches 401 first, refreshes, retries the request,
      //      and only propagates if refresh itself fails (Phase H Stage 1 / ADR-0045)
      withInterceptors([
        apiBaseInterceptor,
        authInterceptor,
        errorInterceptor,
        refreshInterceptor,
      ]),
    ),
    provideAnimationsAsync(),
    provideEchartsCore({ echarts: () => import('echarts') }),
    // Sentry's ErrorHandler is wired up dynamically in main.ts (after the
    // dynamic import resolves) so its ~140kB SDK weight stays out of the
    // initial bundle. Until the dynamic init completes, Angular's default
    // ErrorHandler is in effect — acceptable since errors during the
    // first 100-200ms are extremely rare and Sentry would dedupe them
    // anyway.
  ],
};
